module.exports = __webpack_public_path__ + "img/gnre.d1c6d603.png";